<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['userAccessByDay'],
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: this.$t('Analysis.User.age10'),
            borderColor: '#009CE1',
            borderWidth: 1,
            backgroundColor: '#009CE1',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#009CE1',
            data: this.getCountsByAgeRange('from10to19')
          },
          {
            label: this.$t('Analysis.User.age20'),
            borderColor: '#24AAE6',
            borderWidth: 1,
            backgroundColor: '#24AAE6',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#24AAE6',
            data: this.getCountsByAgeRange('from20to29')
          },
          {
            label: this.$t('Analysis.User.age30'),
            borderColor: '#47B7E9',
            borderWidth: 1,
            backgroundColor: '#47B7E9',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#47B7E9',
            data: this.getCountsByAgeRange('from30to39')
          },
          {
            label: this.$t('Analysis.User.age40'),
            borderColor: '#6BC5EE',
            borderWidth: 1,
            backgroundColor: '#6BC5EE',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#6BC5EE',
            data: this.getCountsByAgeRange('from40to49')
          },
          {
            label: this.$t('Analysis.User.age50'),
            borderColor: '#7FCDF0',
            borderWidth: 1,
            backgroundColor: '#7FCDF0',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#7FCDF0',
            data: this.getCountsByAgeRange('from50to59')
          },
          {
            label: this.$t('Analysis.User.age60'),
            borderColor: '#B2E1F6',
            borderWidth: 1,
            backgroundColor: '#B2E1F6',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#B2E1F6',
            data: this.getCountsByAgeRange('from60to69')
          },
          {
            label: this.$t('Analysis.User.age70'),
            borderColor: '#D6EFFA',
            borderWidth: 1,
            backgroundColor: '#D6EFFA',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#D6EFFA',
            data: this.getCountsByAgeRange('over70')
          },
          {
              label: this.$t('Analysis.User.ageOther'),
              borderColor: '#EEEEEE',
              borderWidth: 1,
              backgroundColor: 'rgba(0,0,0,0.1)',
              pointRadius: 0,
              pointHitRadius: 4,
              pointHoverBackgroundColor: 'rgba(0,0,0,0.1)',
              data: this.getCountsByAgeRange('_unknown')
          }
        ]
      };
    },
    labels: function() {
      return Object.keys(this.userAccessByDay).sort();
    },
    totalCounts() {
      return this.labels.map(date => {
        const dateObject = this.userAccessByDay[date];
        let total = 0;
        for (let gender of [ 'male', 'female', 'other', '_unknown' ]) {
          const genderObject = dateObject[gender];
          if (genderObject) {
            total += Object.values(genderObject).reduce((a,v)=>a+v,0);
          }
        }
        return total;
      });
    }
  },
  methods: {
    getCountsByAgeRange(ageRange) {
      return this.labels.map(date => {
        const dateObject = this.userAccessByDay[date];
        const genders = Object.keys(dateObject);
        return genders.map(gender => dateObject[gender][ageRange]).reduce((a,v)=>isNaN(v)?a:a+v,0);
      }).map((val, index) => this.totalCounts[index] !== 0 ? (val / this.totalCounts[index] * 100) : 0)
        .map(val => Math.round(val * 10) / 10);
    }
  },
  mounted() {
    this.options = {
      plugins: {
        datalabels: {
          display: false
        }
      },
      legend: {
        position: "bottom"
      },
      tooltips: {
        mode: 'x-axis',
        intersect: false,
        position: 'nearest'
      },
      hover: {
        mode: 'x-axis',
        intersect: false
      },
      scales: {
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: "#999"
          }
        }],
        yAxes: [{
          stacked: true,
          ticks: {
            max: 100,
            fontColor: "#999"
          }
        }]
      },
      maintainAspectRatio: false,
      spanGaps: true,
      elements: {
        line: {
          tension: 0
        }
      }
    };
    this.renderChart(this.chartData,this.options);
  },
  watch: {
    userAccessByDay() {
      this.renderChart(this.chartData, this.options);
    }
  }
}
</script>
